import React from "react";
import { ImgV2 } from "../../../ImgV2";
export const MobileSmallAwardCard = ({ mobileAwardImage, title, subtitle, date }) => (React.createElement("div", { className: "mobile-small-award-card" },
    React.createElement(ImgV2, { src: mobileAwardImage }),
    React.createElement("p", { className: "mobile-small-award-card__title" }, title),
    React.createElement("p", { className: "mobile-small-award-card__subtitle" }, subtitle),
    React.createElement("p", { className: "mobile-small-award-card__date" }, date)));
